<template>
    <div class="card-container">
        <common-top-form :model="formModel" @success="onSuccess" :submitService="submitService" :submitData="submitData"
                         :showDownloadPower="true"
                         buttonName="添加" @openAddDialog="openAddDialog" showDownloadPowerType="purple"
                         downloadPowerText="统计分析"
                         downloadPower="/statistics/tatAssets" @down="handleStatistic">
            <select-organs v-model="formModel.tatSimpleId"></select-organs>
        </common-top-form>
        <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
            <el-table-column prop="tatName" label="机构名称" min-width="100" show-overflow-tooltip
                             :formatter="formatterTableData"></el-table-column>
            <el-table-column prop="rewardRate" label="奖励金概率（会员）%" min-width="200" show-overflow-tooltip
                             :formatter="formatterTableNumberYuan"></el-table-column>
            <el-table-column prop="rewardTatRate" label="奖励金概率（机构）%" :formatter="formatterTableNumberYuan"
                             min-width="200"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="transactionRate" label="交易概率%" :formatter="formatterTableNumberYuan"
                             min-width="200"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="transactionFee" label="交易比例%" :formatter="formatterTableNumberYuan"
                             min-width="200"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="createTime" label="创建时间" min-width="160" show-overflow-tooltip
                             :formatter="formatterTableData"></el-table-column>
            <el-table-column prop="updateTime" label="修改时间" min-width="160" show-overflow-tooltip
                             :formatter="formatterTableData"></el-table-column>
            <el-table-column label="操作" fixed="right" min-width="200">
                <template slot-scope="scope">
                    <el-button type="text" @click="goConfig(scope.row)">策略配置</el-button>
                    <el-button type="text" @click="openAddDialog(scope.row)">修改</el-button>
                    <el-button type="text" @click="handleDel(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </common-table>
        <form-dialog ref="formDialog" :formDialogTitle="dialogTitle" :model="dialogModel"
                     :dialogWidth="dialogType == 1 ? '1000px' : '500px'" class="showInfoDialog over"
                     :submitData="dialogData" :rules="dialogRules" :dialogService="dialogService"
                     @success="dialogSuccess" labelWidth="240px" :show="dialogType != 1"
                     @close="dialogClose">
            <div v-if="this.dialogType == 1">
                <common-top-form :model="dialogModel" @success="tableSuccess" :submitService="tableService"
                                 :submitData="tableSubmitData" :show="false" class="flex-row">
                    <select-organs v-model="dialogModel.tatSimpleId" :selectValue="dialogModel.tatSimpleId"></select-organs>
                    <el-form-item label="日期">
                        <el-date-picker
                            v-model="dialogModel.time"
                            type="daterange"
                            value-format="yyyy-MM-dd"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                        </el-date-picker>
                    </el-form-item>
                </common-top-form>
                <common-table :data="dialogTableData" ref="commonTable" :isShow="false" :showSummary="true" :excludeItem="true">
                    <el-table-column prop="orderType" label="类型" min-width="100" show-overflow-tooltip
                                     :formatter="formatterTableType"></el-table-column>
                    <el-table-column prop="fee" label="扣税（元）" min-width="130" show-overflow-tooltip
                                     :formatter="formatterTableNumberYuan"></el-table-column>
                </common-table>
            </div>
            <div v-else>
                <select-organs v-model="dialogModel.tatSimpleId" :selectValue="dialogModel.tatSimpleId" :needAll="false"
                               selectWidth="100%"></select-organs>
                <el-form-item label="奖励金概率（会员）" prop="rewardRate">
                    <div class="flex-row">
                        <el-input-number controls-position="right" :precision="2" :step="0.1" :min="0" :max="100"
                                         :controls="false"
                                         v-model="dialogModel.rewardRate" style="width: 100%"></el-input-number>
                        <span class="formSpan">%</span>
                    </div>
                </el-form-item>
                <el-form-item label="奖励金概率（机构）" prop="rewardTatRate">
                    <div class="flex-row">
                        <el-input-number controls-position="right" :precision="2" :step="0.1" :min="0" :max="100"
                                         :controls="false"
                                         v-model="dialogModel.rewardTatRate" style="width: 100%"></el-input-number>
                        <span class="formSpan">%</span>
                    </div>
                </el-form-item>
                <el-form-item label="交易概率" prop="transactionRate">
                    <div class="flex-row">
                        <el-input-number controls-position="right" :precision="2" :step="0.1" :min="0" :max="100"
                                         :controls="false"
                                         v-model="dialogModel.transactionRate" style="width: 100%"></el-input-number>
                        <span class="formSpan">%</span>
                    </div>
                </el-form-item>
                <el-form-item label="交易比例" prop="transactionFee">
                    <div class="flex-row">
                        <el-input-number controls-position="right" :precision="2" :step="0.1" :min="0" :max="100"
                                         :controls="false"
                                         v-model="dialogModel.transactionFee" style="width: 100%"></el-input-number>
                        <span class="formSpan">%</span>
                    </div>
                </el-form-item>
            </div>
        </form-dialog>
    </div>
</template>

<script>
    import CommonTopForm from 'components/common/CommonTopForm'
    import CommonTable from 'components/common/CommonTable'
    import SelectOrgans from 'components/business/SelectOrgans'
    import FinanceService from 'service/FinanceService'
    import {loadMixin, dialogMixin, validatorsMixin} from "mixin";
    import FormDialog from '../../dialog/FormDialog'
    import {mapGetters} from 'vuex'

    export default {
        name: "taxlogperson",
        data() {
            return {
                formModel: {
                    tatSimpleId: '',
                },
                dialogModel: {
                    time: [],
                    tatSimpleId: '',
                    rewardRate: '',
                    rewardTatRate: '',
                    transactionRate: '',
                    transactionFee: '',
                },
                dialogTableData: [],
                tableData: [],
                submitService: FinanceService.tatTaxMemList,
                page: [],
                types: [],
                isPage: false,
                getTatSimpleId: '',
                dialogRules: {
                    tatSimpleId: [{
                        required: true,
                        validator: (rule, value, callback) => {
                            if (!value) {
                                callback(new Error('请选择机构名称'))
                            } else {
                                if (this.getTatSimpleId == value) {
                                    return callback();
                                }
                                this.checkOnly(value, res => {
                                    res.contents.checkFlag ? callback(new Error('机构名称不能重复')) : callback()
                                });
                            }
                        },
                    }],
                    rewardRate: [{
                        required: true,
                        message: '请输入会员奖励金概率'
                    }],
                    rewardTatRate: [{
                        required: true,
                        message: '请输入机构奖励金概率'
                    }],
                    transactionRate: [{
                        required: true,
                        message: '请输入交易概率'
                    }],
                    transactionFee: [{
                        required: true,
                        message: '请输入交易比例'
                    }],
                },
                dialogId: '',
                dialogType: '',
                tableService: FinanceService.tatTaxMemStatistics
            }
        },
        mixins: [loadMixin, dialogMixin, validatorsMixin],
        components: {
            CommonTopForm,
            CommonTable,
            SelectOrgans,
            FormDialog
        },
        mounted() {
            this.page = this.$refs.commonTable.page;
            this.getTypeNames('个人账户类型', (res) => {
                this.types = res
            });
            this.getList();
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                if (vm.roleYuan.indexOf(vm.userInfo.userName) < 0) {
                    vm.showWarming('您暂无该权限');
                    vm.$router.back(-1);
                }
            })
        },
        computed: {
            dialogTitle() {
                return this.dialogType==1 ? '统计分析' : this.dialogId ? '修改' : '添加';
            },
            dialogService() {
                return this.dialogId ? FinanceService.tatTaxMemEdit : FinanceService.tatTaxMemAdd;
            },
            submitData() {
                const params = {
                    tatSimpleId: this.formModel.tatSimpleId,
                    current: this.isPage ? this.page.currentPage : 1,
                    size: this.page.pageSize,
                };
                return params;
            },
            tableSubmitData() {
                if (this.dialogModel.time == null || this.dialogModel.time == '') {
                    this.dialogModel.time = [];
                }
                const params = {
                    tatSimpleId: this.dialogModel.tatSimpleId,
                };

                if (this.dialogModel.time != null && this.dialogModel.time.length) {
                    params.startDate = this.dialogModel.time[0];
                    params.endDate = this.dialogModel.time[1];
                }
                return params;
            },
            dialogData() {
                const params = {
                    tatSimpleId: this.dialogModel.tatSimpleId,
                    rewardRate: this.dialogModel.rewardRate,
                    rewardTatRate: this.dialogModel.rewardTatRate,
                    transactionRate: this.dialogModel.transactionRate,
                    transactionFee: this.dialogModel.transactionFee,
                };

                if (this.dialogId) {
                    params.id = this.dialogId;
                }

                return params;

            },
            ...mapGetters(['serverType', 'tatId', 'userId', 'userInfo']),
        },
        methods: {
            getPage() {
                this.isPage = true;
                this.getList();
            },
            getList() {
                this.doLoad(this.submitService, this.submitData, res => {
                    this.doCheck(res, res => {
                        this.onSuccess(res);
                        this.isPage = false;
                    });
                }, '信息获取失败')
            },
            onSuccess(data) {
                const result = data.contents;
                this.tableData = result.rows;
                this.page.currentPage = result.current;
                this.page.total = result.total;
                this.page.pageSize = result.size;
            },
            dialogSuccess(res) {
                this.showSuccess(res.respMsg);
                this.$refs.formDialog.closeDialog();
                this.getList();
            },
            dialogClose() {
                this.dialogTableData = [];
                this.dialogModel = {
                    time: [],
                    tatSimpleId: '',
                    rewardRate: '',
                    rewardTatRate: '',
                    transactionRate: '',
                    transactionFee: '',
                }
            },
            openAddDialog(item) {
                this.dialogType = 2;
                this.dialogId = item ? item.id : '';
                this.getTatSimpleId = '';
                if (this.dialogId) {
                    this.dialogModel = JSON.parse(JSON.stringify(item));
                    this.getTatSimpleId = this.dialogModel.tatSimpleId;
                }
                this.$refs.formDialog.open();
            },
            handleStatistic() {
                this.dialogType = 1;
                this.$refs.formDialog.open();
            },
            checkOnly(val, onSuccess) {
                const params = {
                    tatSimpleId: val,
                };
                this.doLoad(FinanceService.TatTaxMemcheckOnly, params, res => {
                    this.doCheck(res, res => {
                        onSuccess && onSuccess(res);
                    });
                }, '信息获取失败')
            },
            handleDel(id) {
                this.showConfirm('确定删除该配置？').then(() => {
                    this.doDel(id)
                }).catch(() => {
                });
            },
            doDel(id) {
                this.doLoad(FinanceService.tatTaxMemDel, {
                    id: id
                }, res => {
                    this.doCheck(res, res => {
                        this.showSuccess(res.respMsg)
                        this.getList();
                    });
                }, '信息获取失败')
            },
            goConfig(item) {
                this.$router.push({
                    name: 'taxmemconfig',
                    params: {
                        item: JSON.stringify(item)
                    }
                })
            },
            tableSuccess(res) {
                this.doCheck(res, res => {
                    const result = res.contents;
                    this.dialogTableData = result ? result : [];
                })
            },
            formatterTableType(row, column, cellValue, index){
                let value = '--';
                this.types.forEach(item => {
                    if (cellValue == item.dictKey) {
                        value = item.dictValue
                    }
                });

                return value
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/page/FinanceManage/TaxLogPerson.vue